import Api from '../utils/Api';
import Config from '../config/Config';

class IdentidadService {

  constructor() {
    this.url = Config.URL_SERVICE;
    this.api = new Api({ url: this.url });
    this.api.createEntities([{ name: 'tarjetacoordenada' }, { name: 'tercerfactor' }]);
  }

  autorizarCordenada(coordenada1, coordenada2, coordenada3, trackId) {
    const bodyRequest = {
      params: {
        coordenada1,
        coordenada2,
        coordenada3
      }
    };
    const config = { headers: { 'trackId': trackId } };
    return this.api.endpoints.tarjetacoordenada
      .createWithAction('validardesafio', bodyRequest, config)
      .then(response => {
        return response.data;
      })
      .catch(error => {
        throw error;
      });
  }

  autorizarSms(otp, trackId) {
    const bodyRequest = {
      params: {
        otp
      }
    };
    const config = { headers: { 'trackId': trackId } };
    return this.api.endpoints.tercerfactor
      .createWithAction('validar', bodyRequest, config)
      .then(response => {
        return response.data;
      })
      .catch(error => {
        throw error;
      });
  }

}

export default new IdentidadService;
